import React from 'react';
import { OnboardingNav } from '../../components/Onboarding/OnboardingNav';
import { SurveyButton } from '../../components/Survey/SurveyButton';
import { SurveyContainer } from '../../components/Survey/SurveyContainer';
import { SurveyWrapper } from '../../components/Survey/SurveyWrapper';
import { formatImageUrl } from '../../utils/images';
import { getProgramDescription } from '../../utils/onboarding/survey';

interface ProgramDisplayProps {
  title: string;
  description: string;
  imageUrl: string;
  onContinue: () => void;
  onStartOver: () => void;
}

export const ProgramDisplay: React.FC<ProgramDisplayProps> = ({
  title,
  description,
  imageUrl,
  onContinue,
  onStartOver,
}) => {
  const formattedImageUrl = formatImageUrl(imageUrl || '');
  const formattedDescriptionLines = getProgramDescription(description).split('\r\n');

  return (
    <div className="onboarding-flow">
      <div className="onboarding-complete onboarding-survey-container">
        <SurveyContainer>
          <SurveyWrapper>
            <OnboardingNav onClick={onStartOver} />
            <div className="survey-program-preview-container">
              {/* Title */}
              <div className="survey-program-header">
                <span className="survey-program-start-today">START TODAY</span>
                <span className="survey-program-recommendation">Your Recommended Program:</span>
                <h1 className="survey-program-title">{title}</h1>
              </div>

              {/* Separator */}
              <div className="survey-program-separator" />

              {/* Preview */}
              <div className="survey-program-preview">
                {imageUrl && <img src={formattedImageUrl} alt="Program Preview" />}
                <div className="survey-program-preview-content">
                  <div className="survey-program-description">
                    {formattedDescriptionLines.map(line => (
                      <span key={line}>
                        {line}
                        <br />
                      </span>
                    ))}
                  </div>
                  <div className="survey-program-btn-container">
                    <SurveyButton className="survey-primary-btn" onClick={onContinue}>
                      Start Today
                    </SurveyButton>
                  </div>
                </div>
              </div>
            </div>
          </SurveyWrapper>
        </SurveyContainer>
      </div>
    </div>
  );
};
